import * as z from 'zod/mini'

export const JoinUserNotification = 'joinUserNotifications'

/**
 * Joins the room of a premise's public calendar. Needs no sign-in: what the room will announce is
 * already public. Nothing emits to it yet; live timetable updates are a follow-up (docs/events.md).
 */
export const JoinPublicCalendar = 'joinPublicCalendar'
export const joinPublicCalendarPayload = z.object({ entityId: z.uuid() })
export type JoinPublicCalendarPayload = z.infer<typeof joinPublicCalendarPayload>

export enum NotificationEvent {
  NewNotification = 'newNotification',
}

export type JoinEvents = typeof JoinUserNotification | typeof JoinPublicCalendar
